import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.scss';

export function Copyright() {
  const { t } = useTranslation();
  return (
    <div className={styles.copyright}>
      <p>{t('seven_days_a_week_10am_8pm_est')}</p>
      <p>{t('copyright_barking_labs')}</p>
    </div>
  );
}
